import { authGuardAdminRoutes } from 'src/routes/types/auth-guard-admin-routes';
import React, { useContext } from 'react';
import { Context } from 'src/context';

export function useHasUserPermission() {
  const { userPermissions, userAuth } = useContext(Context);

  const hasUserPermissionByPermission = (permission: string = '') => {
    if (!userAuth?.admin) return true
    return userPermissions && userPermissions.length > 0 && userPermissions?.includes(permission)
  }

  const hasUserPermissionByLocation = (pathName: string = '') => {
    if (!userAuth?.admin) return true
    const permissionAdminRoute = authGuardAdminRoutes?.find(route => route.path === pathName)?.permission || ''
    return !permissionAdminRoute || (userPermissions && userPermissions.length > 0 && userPermissions?.includes(permissionAdminRoute))
  }

  return { hasUserPermissionByPermission, hasUserPermissionByLocation };
}

